import {
  CHART_COLOR,
  CHART_LABEL,
  CHART_LAYOUT,
  CHART_TEXT,
  LEGEND_SPLIT_THRESHOLD
} from "../recipeImpactChart.constants";
import { BreakdownItem } from "../recipeImpactChart.types";

/** Builds a single- or double-row scrolling legend depending on item count. */
export const buildLegend = (items: BreakdownItem[]) => {
  const names = items.map(item => item.name || CHART_LABEL.unknown);
  const base = {
    type: "scroll",
    left: "center",
    orient: "horizontal",
    inverse: true,
    textStyle: { fontSize: CHART_LAYOUT.legendFontSize },
    itemWidth: CHART_LAYOUT.legendItemWidth,
    itemHeight: CHART_LAYOUT.legendItemHeight
  };

  if (items.length > LEGEND_SPLIT_THRESHOLD) {
    const mid = Math.ceil(items.length / 2);
    return [
      { ...base, top: CHART_LAYOUT.legendTopFirstRow, data: names.slice(0, mid) },
      { ...base, top: CHART_LAYOUT.legendTopSecondRow, data: names.slice(mid) }
    ];
  }

  return [{ ...base, top: CHART_LAYOUT.legendTopSingle, data: names }];
};

export const buildTooltip = (seriesColorMap: Record<string, string>) => ({
  trigger: "axis",
  axisPointer: { type: "shadow" },
  formatter: (params: any) => {
    let content = `<b>${params[0].axisValue}</b><br/>`;
    params.reverse().forEach((point: any) => {
      if (point.value > 0) {
        const color = seriesColorMap[point.seriesName];
        const marker = color
          ? `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>`
          : point.marker;
        content += `${marker} ${point.seriesName}: ${point.value.toFixed(3)}<br/>`;
      }
    });
    return content;
  }
});

export const buildTitle = () => ({
  text: CHART_TEXT.title,
  left: "left",
  padding: CHART_LAYOUT.titlePadding,
  textStyle: {
    fontSize: CHART_LAYOUT.titleFontSize,
    fontWeight: "bold",
    color: CHART_COLOR.title
  }
});
